import { AnytimeListPage } from "@/features/anytime/pages/AnytimeList";
import React from "react";

const AnytimeList = () => {
  return <AnytimeListPage />;
};

export default AnytimeList;
